/* Track feature usage for the tip engine. Deduplicates within session via Set ref. */

import { useCallback, useRef } from "react";
import { useMutation } from "convex/react";
import { api } from "../../convex/_generated/api";

export function useFeatureTracking() {
  const trackMutation = useMutation(api.tips.trackFeatureUsage);
  const trackedRef = useRef(new Set<string>());

  const trackFeature = useCallback(
    (featureId: string) => {
      if (trackedRef.current.has(featureId)) return;
      trackedRef.current.add(featureId);
      void trackMutation({ featureId });
    },
    [trackMutation],
  );

  return { trackFeature };
}
